import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { SharedService } from '../../_service/shared.service';
import { ActivatedRoute, Router } from '@angular/router';
import { PageEvent, MatPaginator } from '@angular/material/paginator';
import { MiscService } from '../../_service/misc.service';
declare var $: any;

@Component({
  selector: 'app-manage-cities',
  templateUrl: './manage-cities.component.html',
  styleUrls: ['./manage-cities.component.css']
})
export class ManageCitiesComponent implements OnInit {

  @ViewChild(MatPaginator) paginator: MatPaginator;

  perpage: number = 25; citiesList: any = []; length: number = 0; pageEvent: PageEvent; loading: boolean = true; myrole: string;
  pageSizeOptions = [10, 25, 50, 100]; pageIndex: number = 0; loaded: boolean = false;
  search: string; currentUserId: any; status = ''; treatCategory = []; tcatergory = '';
  booleanValue: any = false; cm_access = '';
  constructor(public miscapi: MiscService, private sharedapi: SharedService, private myRoute: Router) { }

  ngOnInit(): void {
    this.sharedapi.getRole().subscribe((item: string) => { this.myrole = item; });
    this.myrole = localStorage.getItem('role');
    this.cm_access = localStorage.getItem('CMAccess');
    this.currentUserId = localStorage.getItem('loginuserId');
  }

  ngAfterViewInit() {
    this.loadCitiesList(0, this.perpage);
  }

  async loadCitiesList(pageIndex, perpage) {
    this.citiesList = [];
    this.paginator.pageIndex = pageIndex;
    let qString = 'search=' + this.search;
    this.loading = true; this.loaded = false;
    this.miscapi.getCities(this.paginator.pageIndex, perpage, qString).subscribe((data: any) => {
    this.length = parseInt(data.totaldata);
    this.loading = false;
    this.loaded = true;
    if (data.status) {
      this.citiesList = data.data;
    } else {
      this.citiesList = [];
    }
    }, error => {
    this.loading = false;
    this.loaded = true;
    this.sharedapi.checkError(error);
    });
  }

  pageChange(event) {
    this.pageIndex = event.pageIndex;
    this.loadCitiesList(event.pageIndex, event.pageSize);
  }

  public getServerData(event: PageEvent): any {
    this.perpage = event.pageSize;
    this.pageIndex = event.pageIndex;
    this.loadCitiesList(event.pageIndex, event.pageSize);
  }



}
